import { applyBasicStyling } from '../text-field';
import { CMSField } from '@cr38te/cr38te-cms';

const Field = applyBasicStyling(CMSField);

export default Field;